import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { siteConfig } from './config/site';
import './index.css';

// 动态更新HTML meta标签
function updateMetaTags() {
  document.title = `${siteConfig.name} - ${siteConfig.titleSuffix}`;
  
  const descriptionMeta = document.querySelector('meta[name="description"]');
  if (descriptionMeta) {
    descriptionMeta.setAttribute('content', `${siteConfig.name} - ${siteConfig.description}`);
  }
  
  const authorMeta = document.querySelector('meta[name="author"]');
  if (authorMeta) {
    authorMeta.setAttribute('content', siteConfig.author);
  }
  
  const appleMobileWebAppTitleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (appleMobileWebAppTitleMeta) {
    appleMobileWebAppTitleMeta.setAttribute('content', siteConfig.shortName);
  }
  
  const applicationNameMeta = document.querySelector('meta[name="application-name"]');
  if (applicationNameMeta) {
    applicationNameMeta.setAttribute('content', siteConfig.shortName);
  }
}

updateMetaTags();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

const savedTheme = localStorage.getItem('ossshelf-theme');
if (savedTheme) {
  try {
    const parsed = JSON.parse(savedTheme);
    const theme = parsed?.state?.theme || 'system';
    const root = document.documentElement;
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const effectiveTheme = theme === 'system' ? (prefersDark ? 'dark' : 'light') : theme;

    if (effectiveTheme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  } catch {
    // ignore
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      });
      console.log('Service Worker registered:', registration.scope);

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('New content available, please refresh.');
            }
          });
        }
      });
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  });
}
